<template>
  <div>
    <base-material-card
      :color="color"
      icon="mdi-chart-timeline-variant"
      class="px-5 py-3"
      :title="$t('UniverseDetails.Title')"
      :subtitle="$t('UniverseDetails.Universe') + ' ' + $t(tabItems[tab].text)"
    >
      <!-- Création des onglets (navigation) -->
      <v-tabs
        v-model="tab"
        fixed-tabs
        background-color="white"
        :color="color"
        light
        show-arrows
      >
        <v-tab
          v-for="item in tabItems"
          :key="item.text"
        >
          {{ $t(item.text) }}
        </v-tab>
      </v-tabs>

      <!-- Création des onglets (contenu) pour le formulaire de modification -->
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in tabItems"
          :key="item.text"
        >
          <v-row align="center">
            <v-col
              cols="12"
              :xl="gridSpacing.xl"
              :lg="gridSpacing.lg"
              :md="gridSpacing.md"
              :sm="gridSpacing.sm"
            >
              <!-- Courbes Évolution des thématiques Univers -->
              <line-charts-ressenti
                :request="request"
                :is-admin="isAdmin"
                :error-msg="errorMsg"
                :error-empty="errorEmpty"
                color="secondary"
                :thematic="item.value"
                @set-error="$emit('set-error', $event)"
              />
            </v-col>
            <v-col
              cols="12"
              :xl="gridSpacing.xl"
              :lg="gridSpacing.lg"
              :md="gridSpacing.md"
              :sm="gridSpacing.sm"
            >
              <results-by-questions
                :request="request"
                :is-admin="isAdmin"
                :error-msg="errorMsg"
                :error-empty="errorEmpty"
                color="secondary"
                :thematic="item.value"
                @set-error="$emit('set-error', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <results-by-questions-thematic
              :request="request"
              :is-admin="isAdmin"
              :error-msg="errorMsg"
              :error-empty="errorEmpty"
              color="secondary"
              :thematic="item.value"
              @set-error="$emit('set-error', $event)"
            />
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </div>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import LineChartsRessenti from '../../charts/LineChartsRessenti.vue'
  import ResultsByQuestions from '../../tables/ResultsByQuestions.vue'
  import ResultsByQuestionsThematic from '../../tables/ResultsByQuestionsThematic.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'UniversDetails',

    /* Sous-composants utilisés par ce composant */
    components: {
      LineChartsRessenti,
      ResultsByQuestions,
      ResultsByQuestionsThematic,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: 'Un problème est survenu.',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        tab: 0,
        tabItems: [
          {
            value: 'Moi',
            text: 'UniverseDetails.Me',
          },
          {
            value: 'Mes Relations',
            text: 'UniverseDetails.MyRelationships',
          },
          {
            value: 'Mon Environnement',
            text: 'UniverseDetails.MySurroundings',
          },
        ],
        gridSpacing: {
          xl: '6',
          lg: '6',
          md: '6',
          sm: '12',
          xs: '12',
        },
        title: {
          thematicsMoi: 'Évolution des thématiques',
          thematicsMonEnvironnement: 'Évolution des thématiques',
          thematicsMesRelations: 'Évolution des thématiques',
        },
        subtitle: {
          thematicsMoi: 'Univers Moi',
          thematicsMonEnvironnement: 'Univers Mon Environnement',
          thematicsMesRelations: 'Univers Mes Relations',
        },
      }
    },
  }
</script>
